import React, { useContext } from 'react';
import styled, { css } from 'styled-components';
import { useTranslate } from 'react-t7e';
import { route } from 'src/services/route';
import Calendar from 'src/components/icons/Calendar';
import { FullWidthButton } from 'src/components/common/Button';
import { ChevronRight } from 'src/components/icons/ChevronRight';
import { EventPageContext } from 'src/modules/events/components/EventPage/EventPageContext';
import { useFlattenEvent } from 'src/modules/events/hooks/useFlattenEvent';
import { casePathEmptyString } from 'src/utils/casePathEmptyString';
import { media } from 'src/styles/designs';
import { UserEventsEventButton } from 'src/modules/events/components/UserEvents/UserEventsEventButton';

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  max-width: 500px;
  gap: 8px;

  margin-top: 24px;

  ${media.w.greaterThanOrEqual.desktop} {
    grid-template-columns: 1fr 1fr;
  }
`;

const CalendarButton = styled(FullWidthButton)<{ $short: boolean }>`
  order: -1;
  ${casePathEmptyString('$short')(css`
    order: 1;
    margin: 12px 4px 0;
    min-width: max-content !important;
    max-width: max-content !important;
  `)}
`;

export const EventPageHeaderContentCTAs = () => {
  const { _ } = useTranslate();

  const { event, isUpcoming } = useContext(EventPageContext);

  const flatEvent = useFlattenEvent(event);

  const hasUpcomingCtaLink = !!(
    flatEvent.upcomingCtaLink && flatEvent.upcomingCtaLabel
  );

  return (
    <Container>
      {hasUpcomingCtaLink && (
        <FullWidthButton
          variant="secondary"
          forwardedAs="a"
          href={flatEvent.upcomingCtaLink}
          icon={ChevronRight}
          iconProps={{ position: 'right', size: 12 }}
        >
          {flatEvent.upcomingCtaLabel}
        </FullWidthButton>
      )}

      <UserEventsEventButton
        event={event}
        variant={!hasUpcomingCtaLink && !isUpcoming ? 'secondary' : 'primary'}
      />

      {isUpcoming && (
        <CalendarButton
          forwardedAs="a"
          $short={hasUpcomingCtaLink}
          kind={hasUpcomingCtaLink ? 'text' : 'default'}
          variant={hasUpcomingCtaLink ? 'primary' : 'secondary'}
          href={route.event(event).ics()}
          icon={Calendar}
          iconProps={{
            position: hasUpcomingCtaLink ? 'left' : 'right',
            size: 12,
          }}
        >
          {_('Add to calendar')}
        </CalendarButton>
      )}
    </Container>
  );
};
